export function getMaxDate(dates: string[]): Date
{
    const asDates = dates.map(d => Date.parse(d));
    const maxDate = Math.max(...asDates);
    return new Date(maxDate);
}
